import React from "react";
import { Trans } from "react-i18next";

const ZatcaSection = () => (
    <section class="zatca my-3 py-5" id="">
        <h2 className="txt-title text-center my-2">
            <Trans>Your Trusted Electronic Invoice Solution</Trans>
        </h2>
        <div className="row text-center my-2">
            <div className="col-12">
                <p><Trans>Dear Xero clients, you can stay compliant with ZATCA phase 2 using Hesaab, The Approved electronic invoicing solution</Trans></p>
            </div>
        </div>
        <div className="row my-2 justify-content-center align-items-center">
            <div className="col-md-6 col-sm-12 px-sm-0 px-md-5">
                <div className="row justify-content-center">
                    <div className="col-3 left-icon">
                        <img src="/images/logo.svg" alt="Hesaab Logo" className="img-fluid border rounded-circle p-2 bg-white" />
                    </div>
                    <div className="col-4 text-center my-3">
                        <div className="h-100 position-relative">
                            <div className="line-h lineh1"></div>
                            <div className="line-h lineh2"></div>
                            <div className="line-h lineh3"></div>
                            <div className="line-h lineh4"></div>
                            <div className="line-h lineh5"></div>
                            <div className="line-h lineh6"></div>
                        </div>
                    </div>
                    <div className="col-3 right-icon">
                        <img src="/images/applications/zatca-icon.png" alt="Arabic Invoicing Solution" className="img-fluid p-2" />
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-sm-12 px-sm-0 px-md-5">
                <div className="row justify-content-start">
                    <div className="col-sm-12 col-md-8 inv-preview preview1">
                        <img src="/images/landing/zatca-integration.png" className="img-fluid" alt="Invoice from Xero" />
                    </div>
                </div>
            </div>
        </div>
        <div className="my-5 text-center">
            <p>
                <Trans>You can use Hesaab's QR code on invoices for instant verification and compliance checks.</Trans>
            </p>
            <p className="font-weight-bold">
                *<Trans>Please contact the team to provide you with the details and procedures required for the Phase Two E-Invoicing (ZATCA) integration.</Trans>
            </p>
        </div>
    </section>
);

export default ZatcaSection;
